import {CommonModule} from '@angular/common';
import {Component, forwardRef, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {GateweeExpandChevronComponent} from '../gatewee-expand-chevron/gatewee-expand-chevron.component';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';
import {
  GateweeDocSidebarComponent,
  GateweeDocSidebarItem,
} from './gatewee-doc-sidebar.component';

@Component({
  selector: 'gatewee-doc-sidebar-node',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    GateweeIconComponent,
    GateweeExpandChevronComponent,
    forwardRef(() => GateweeDocSidebarNodeComponent),
  ],
  templateUrl: './gatewee-doc-sidebar-node.component.html',
})
export class GateweeDocSidebarNodeComponent {
  @Input() items: GateweeDocSidebarItem[] = [];
  @Input() depth = 0;
  @Input({required: true}) sidebar!: GateweeDocSidebarComponent;
}
